const ReactImageBanner = props => {
  const deadline = props.deadline;
  const url = props.url;
  const currentDesktopBanner = props.currentDesktopBanner;
  const scheduledDesktopBanner = props.scheduledDesktopBanner;
  const currentMobileBanner = props.currentMobileBanner;
  const scheduledMobileBanner = props.scheduledMobileBanner;
  let contentContainerClass = 'image-banner-content-container';
  if (props.leftAlign) {
    contentContainerClass = 'left-align-Container';
  } else if (props.bottomAlign) {
    contentContainerClass = 'bottom-align-Container';
  }
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  React.useEffect(() => {
    function handleResize() {
      setWindowWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return _ => {
      window.removeEventListener('resize', handleResize);
    };
  });
  if (windowWidth > 589) return /*#__PURE__*/React.createElement("div", {
    className: "tlf-banner"
  }, url ? /*#__PURE__*/React.createElement("a", {
    href: url
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-banner-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "desktop-image banner-image",
    alt: "TLF Promo Banner",
    width: "1024",
    height: "auto",
    src: Date.parse(deadline) - Date.parse(new Date().toLocaleString("en-US", {
      timeZone: "America/New_York"
    })) > 0 ? currentDesktopBanner : scheduledDesktopBanner
  }), /*#__PURE__*/React.createElement("div", {
    className: "image-banner-content-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: contentContainerClass
  }, props.children)))) : /*#__PURE__*/React.createElement("div", {
    className: "image-banner-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "desktop-image banner-image",
    alt: "TLF Promo Banner",
    width: "1024",
    height: "auto",
    src: Date.parse(deadline) - Date.parse(new Date().toLocaleString("en-US", {
      timeZone: "America/New_York"
    })) > 0 ? currentDesktopBanner : scheduledDesktopBanner
  }), /*#__PURE__*/React.createElement("div", {
    className: "image-banner-content-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: contentContainerClass
  }, props.children))));else return /*#__PURE__*/React.createElement("div", {
    className: "tlf-banner"
  }, url ? /*#__PURE__*/React.createElement("a", {
    href: url
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-banner-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "mobile-image banner-image",
    alt: "TLF Promo Banner",
    width: "600",
    height: "auto",
    src: Date.parse(deadline) - Date.parse(new Date().toLocaleString("en-US", {
      timeZone: "America/New_York"
    })) > 0 ? currentMobileBanner : scheduledMobileBanner
  }), /*#__PURE__*/React.createElement("div", {
    className: "image-banner-content-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: contentContainerClass
  }, props.children)))) : /*#__PURE__*/React.createElement("div", {
    className: "image-banner-container"
  }, /*#__PURE__*/React.createElement("img", {
    className: "mobile-image banner-image",
    alt: "TLF Promo Banner",
    width: "600",
    height: "auto",
    src: Date.parse(deadline) - Date.parse(new Date().toLocaleString("en-US", {
      timeZone: "America/New_York"
    })) > 0 ? currentMobileBanner : scheduledMobileBanner
  }), /*#__PURE__*/React.createElement("div", {
    className: "image-banner-content-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: contentContainerClass
  }, props.children))));
};
